import { render } from "./MultiColumnForm.vue?vue&type=template&id=71ff4ec1"
import script from "./MultiColumnForm.vue?vue&type=script&lang=js"
export * from "./MultiColumnForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omninext/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__